import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FlightOrderCard from "./FlightOrderCard/FlightOrderCard";
import "../index.css";

function KiwiFlightOrderCard({ order, ...props }) {
  const { flight_data } = order;
  const flightOrder = {
    status: order?.status?.toUpperCase(),
    order_amount: order?.order_amount,
    amount: order?.amount,
    currency: flight_data?.conversion?.currency,
    booking_id: order?.booking_id,
    createdAt: order?.createdAt,
    updatedAt: order?.updatedAt,
    flight_data: {
      origin: flight_data?.flights?.slice(0)?.src_name,
      destination: flight_data?.flights?.slice(-1)?.dst_name,
      segments: flight_data?.flights?.map(
        ({
          airline,
          local_departure,
          local_arrival,
          utc_arrival,
          utc_departure,
          src,
          dst,
          fare_category,
          flight_no,
          src_name,
          dst_name,
          vi_connection,
          is_self_transfer,
        }) => ({
          airline: airline.code,
          local_departure,
          local_arrival,
          utc_departure,
          utc_arrival,
          flyFrom: src,
          flyTo: dst,
          fare_category,
          flight_no,
          cityFrom: src_name,
          is_self_transfer,
          vi_connection,
          cityTo: dst_name,
        })
      ),
    },
    passenger_data: order?.passenger_data,
  };

  return <FlightOrderCard props={props} order={flightOrder} />;
}
export default KiwiFlightOrderCard;
